import Banner from "../../../assets/images/SuccessSigning.jpg"
import Logo from "../../../assets/images/logo.png"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useThemeContext } from "../../../theme/ThemeContext"
import { signedCopyKept, forgetSignedCopy, downloadSignedCopy } from "../../../utils/signedCopy"


const firmLogoOf = (firmBrand, mode) => {
  if (mode === 'dark' && firmBrand.logoUrlDark) return { src: firmBrand.logoUrlDark, silhouette: false }
  if (firmBrand.logoUrl) return { src: firmBrand.logoUrl, silhouette: mode === 'dark' }
  return null
}

const FirmLogo = ({ firmBrand, mode }) => {
  const [failedSrc, setFailedSrc] = useState(null)
  const logo = firmLogoOf(firmBrand, mode)
  if (!logo || failedSrc === logo.src) return null

  return (
    <div className="ml-[40px] mt-[40px] mr-[12px]">
      <img
        src={logo.src}
        alt={firmBrand.name || ''}
        className={['h-[50px] w-auto max-w-[200px] object-contain', logo.silhouette && 'brightness-0 invert'].filter(Boolean).join(' ')}
        onError={() => setFailedSrc(logo.src)}
      />
    </div>
  )
}

const SuccessSigning = () => {
  const location = useLocation()
  const { text, firmBrand } = location.state || {}
  const { mode } = useThemeContext()
  // WS #2219705: the agreement just signed on this tab (LSA_SIGNED_COPY_DOWNLOAD). Held only while this page
  // is open; a reload or a later visit has none.
  const [signedCopy] = useState(signedCopyKept)
  useEffect(() => () => forgetSignedCopy(), [])

  return (
    <div className="flex max-h-[100vh] w-full">
      <div className="w-full h-screen overflow-hidden max-w-[708px] hidden md:block">
        <img src={Banner} alt="overlay" className="h-screen w-full object-cover object-bottom" />
      </div>
      <div className="w-full">
        {firmBrand ? (
          <FirmLogo firmBrand={firmBrand} mode={mode} />
        ) : (
          <div className="ml-[40px] mt-[40px] mr-[12px] w-[50px]">
            <img src={Logo} alt="logo" className={mode === 'dark' ? 'brightness-0 invert' : ''} />
          </div>
        )}
        <div className="h-screen w-full flex justify-center items-center">
          <div className="text-center p-9">
            <h4 className="text-[86px] leading-[97px] w-full font-bold mb-6">THANK YOU!</h4>
            <div className="my-[50px]">
              {text?.heading ? (
                <>
                  <p className="text-2xl font-semibold text-text-primary mb-4">{text.heading}</p>
                  <p className="text-lg text-text-secondary">{text.subtext}</p>
                </>
              ) : text ? text : (
                <>
                  The Document has been successfully signed and saved!<br />
                  There are no new Docs for signing so far.
                </>
              )}
            </div>
            {signedCopy && (
              <button
                type="button"
                onClick={() => downloadSignedCopy(signedCopy, 'Signed agreement.pdf')}
                className="rounded-lg px-[22px] py-3.5 text-lg font-semibold bg-primary-main text-primary-contrast hover:bg-primary-main/90"
              >
                Download your signed agreement
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SuccessSigning
